import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './TextFilter.css';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import addQueryString, { removeQueryString } from "./index";
import { qsToObject } from "../../utils/querystring";
import { get } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from "../../utils/tealium";
import getListing from '../../utils/getListing';
var SuggestionsList = function SuggestionsList(_ref) {
  var suggestionList = _ref.suggestionList,
    setIsOpen = _ref.setIsOpen,
    sendRequestHandler = _ref.sendRequestHandler,
    analytics = _ref.analytics,
    fields = _ref.fields;
  var drop = React.useRef(null);
  var filterName = get(fields, 'name');
  var handleOutClick = function handleOutClick(_ref2) {
    var target = _ref2.target;
    if (!drop.current.contains(target)) {
      setIsOpen(false);
    }
  };
  var handleItemClick = function handleItemClick(title) {
    sendRequestHandler(title);
    setIsOpen(false);
    tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), "".concat(filterName, " : ").concat(title));
  };
  React.useEffect(function () {
    document.body.addEventListener('click', handleOutClick);
    return function () {
      return document.body.removeEventListener('click', handleOutClick);
    };
  }, []);
  return /*#__PURE__*/React.createElement("ul", {
    className: "suggestions-list text-filter",
    ref: drop
  }, suggestionList.map(function (suggestion) {
    return /*#__PURE__*/React.createElement("li", {
      tabIndex: 0,
      className: "suggestion-item",
      onClick: function onClick() {
        return handleItemClick(suggestion.title);
      },
      onKeyPress: function onKeyPress(event) {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      }
    }, suggestion.title);
  }));
};
var TextFilter = function TextFilter(_ref3) {
  var fields = _ref3.fields,
    params = _ref3.params,
    showLabel = _ref3.showLabel,
    resultsLabel = _ref3.resultsLabel,
    clearAllLabel = _ref3.clearAllLabel,
    facets = _ref3.facets,
    nbHits = _ref3.nbHits,
    setFilter = _ref3.setFilter,
    facetsName = _ref3.facetsName,
    fullWidth = _ref3.fullWidth,
    indexDropDown = _ref3.indexDropDown,
    firstQuery = _ref3.firstQuery,
    firstFilter = _ref3.firstFilter,
    wrapperToggle = _ref3.wrapperToggle,
    defaultFacets = _ref3.defaultFacets,
    setSubpanelLabel = _ref3.setSubpanelLabel,
    clearAlllFilters = _ref3.clearAlllFilters,
    rtl = _ref3.rtl,
    analytics = _ref3.analytics,
    getFilterValue = _ref3.getFilterValue,
    _ref3$columnsClass = _ref3.columnsClass,
    columnsClass = _ref3$columnsClass === void 0 ? 'col-md-4' : _ref3$columnsClass;
  var history = useHistory();
  var label = get(fields, 'title.jss.value');
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    suggestionList = _React$useState2[0],
    setSuggestionList = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isOpen = _React$useState4[0],
    setIsOpen = _React$useState4[1];
  var borderRadius = {
    borderRadius: '4px 4px 0 0'
  };
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    value = _React$useState6[0],
    setValue = _React$useState6[1];
  var _React$useState7 = React.useState([]),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    hits = _React$useState8[0],
    setHits = _React$useState8[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    highLightText = _useState2[0],
    setHighLightText = _useState2[1];
  var clickedTextRef = useRef(false);
  var algoliaIndex = get(params, 'SearchIndex');
  useEffect(function () {
    var itemFilters = {
      query: value
    };
    getListing(algoliaIndex, itemFilters).then(function (response) {
      setHits(response.hits);
    });
  }, [value]);
  var inputHandler = function inputHandler(_ref4) {
    var target = _ref4.target;
    setIsOpen(true);
    var list = hits.filter(function (_ref5) {
      var title = _ref5.title;
      return target.value && ~title.toString().toLowerCase().indexOf(target.value.toLowerCase());
    });
    setSuggestionList(list);
    setValue(target.value);
  };
  var sendRequestHandler = function sendRequestHandler(title) {
    setValue(title);
    getFilterValue && getFilterValue(fields.name, facetsName, title);
    addQueryString(facetsName, title, history);
    setFilter(title);
  };
  var clearFilter = function clearFilter() {
    setValue('');
    removeQueryString(facetsName, history);
    getFilterValue && getFilterValue(fields.name, facetsName, null);
  };
  React.useEffect(function () {
    if (clearAlllFilters) {
      clearFilter();
    }
  }, [clearAlllFilters]);
  React.useEffect(function () {
    if (typeof window !== "undefined") {
      var urlParams = qsToObject(window.location.href);
      var title = urlParams['title'];
      if (title) {
        setValue(title.split('+').join(' '));
      }
    }
  }, []);
  var handleTextBlur = function handleTextBlur() {
    clickedTextRef.current = false;
    setHighLightText(false);
  };
  var handleTextMousedown = function handleTextMousedown() {
    clickedTextRef.current = true;
  };
  var handleTextFocus = function handleTextFocus() {
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    fullWidth: fullWidth,
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field "
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "\n                        input-text-primary\n                        input-search-text\n                        ".concat(highLightText ? 'input-text-primary--focused' : '', "\n                        ").concat(isOpen ? 'input-search-text--openedDrop' : '', "\n                      "),
    placeholder: label,
    style: isOpen && suggestionList.length ? borderRadius : undefined,
    value: value,
    onChange: inputHandler,
    onClick: function onClick() {
      return setIsOpen(true);
    },
    onMouseDown: handleTextMousedown,
    onFocus: handleTextFocus,
    onBlur: handleTextBlur
  }), /*#__PURE__*/React.createElement("span", {
    className: "search-icon ".concat(rtl ? 'search-icon-left' : 'search-icon-right')
  })), isOpen && /*#__PURE__*/React.createElement(SuggestionsList, {
    suggestionList: suggestionList,
    setIsOpen: setIsOpen,
    sendRequestHandler: sendRequestHandler,
    fields: fields,
    analytics: analytics
  })));
};
var StyledWrapper = function StyledWrapper(_ref6) {
  var children = _ref6.children,
    fullWidth = _ref6.fullWidth,
    columnsClass = _ref6.columnsClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(fullWidth ? 'col-12' : columnsClass)
  }, children);
};

// export default DropDown;
export default TextFilter;
var commonStyles = "cf3szg5";